import * as React from 'react'
import { GbImage, RuImage } from '../images/images.tsx'
import { Popover } from '../popover/popover.tsx'
import { AppLanguages } from '../../translations/messages.ts'
import { cn } from '../../lib/utils.ts'

function LanguageButton(props: {
  language: AppLanguages
  item?: boolean
  darkBorder?: boolean
  grayText?: boolean
}) {
  const name = props.language == 'ru' ? 'Русский' : 'English'
  const Icon = props.language == 'ru' ? RuImage : GbImage
  return (
    <div className="flex items-center justify-between gap-8 font-nunito-7-semicondensed text-14 font-bold">
      <div
        className={cn(
          props.item && 'hidden text-black sm:block',
          props.grayText && 'text-light',
        )}
      >
        {name}
      </div>
      <div
        className={cn(
          'flex size-[38px] shrink-0 items-center justify-center overflow-hidden rounded-full border-2 p-2',
          props.darkBorder ? 'border-gray8' : 'border-white',
        )}
      >
        <Icon className="rounded-4" width={28} height={28} />
      </div>
    </div>
  )
}

export const SwitchLanguage = (props: {
  language: AppLanguages
  onChange: (lang: AppLanguages) => void
  darkBorder?: boolean
  grayText?: boolean
}) => {
  const [open, setOpen] = React.useState(false)

  const handleLanguageChange = (lang: AppLanguages) => {
    props.onChange(lang)
    setOpen(false)
  }

  return (
    <Popover.Root
      open={open}
      onOpenChange={(isOpen) => {
        setOpen(isOpen)
      }}
    >
      <Popover.Trigger className="text-white">
        <LanguageButton
          darkBorder={props.darkBorder}
          language={props.language}
          item={true}
          grayText={props.grayText}
        />
      </Popover.Trigger>
      <Popover.Content>
        <div className="flex flex-col gap-8">
          <button
            onClick={() => {
              handleLanguageChange('en')
            }}
          >
            <LanguageButton language="en" grayText={props.grayText} />
          </button>
          <button
            onClick={() => {
              handleLanguageChange('ru')
            }}
          >
            <LanguageButton language="ru" grayText={props.grayText} />
          </button>
        </div>
      </Popover.Content>
    </Popover.Root>
  )
}
